import { render, staticRenderFns } from "./ModalRevisaoCirurgicaAutorizacao.vue?vue&type=template&id=2745ceec&scoped=true"
import script from "./ModalRevisaoCirurgicaAutorizacao.vue?vue&type=script&lang=ts"
export * from "./ModalRevisaoCirurgicaAutorizacao.vue?vue&type=script&lang=ts"
import style0 from "./ModalRevisaoCirurgicaAutorizacao.vue?vue&type=style&index=0&id=2745ceec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2745ceec",
  null
  
)

export default component.exports